module.exports = __webpack_public_path__ + "static/media/powered-wolly-logo.e49dc490.png";